import {
  REMOVE_DRIVER_ACCESS_REQUEST,
  REMOVE_DRIVER_ACCESS_SUCCESS,
  REMOVE_DRIVER_ACCESS_FAILURE,
} from '~/common/redux/types';

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_DRIVER_ACCESS_REQUEST:
      return {
        ...initialState,
        isLoading: true,
      };
    case REMOVE_DRIVER_ACCESS_SUCCESS:
      return {
        isLoading: false,
        isLoaded: true,
        error: false,
      };
    case REMOVE_DRIVER_ACCESS_FAILURE:
      return {
        isLoading: false,
        isLoaded: true,
        error: true,
      };
    default:
      return state;
  }
};
